import { GetSalaryChangeRequestsResponse } from 'api/laborerPortalAPI/authContract'
import { CallAPIAction, Status } from 'api/types'
import {
  convertSalaryChangeRequestFromResponse,
  LaborerSalaryChangeRequest,
} from 'common/utils/convertResponse/convertLaborerAuthResponse'
import Actions from 'redux/actions'

type State = {
  requests: Array<LaborerSalaryChangeRequest>
} & Status

const initialState: State = {
  requests: [],
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.GET_LABORER_SALARY_CHANGE_REQUESTS_ASYNC,
    Actions.GET_LABORER_SALARY_CHANGE_REQUESTS_SUCCESS,
    Actions.GET_LABORER_SALARY_CHANGE_REQUESTS_FAIL,
    GetSalaryChangeRequestsResponse
  >,
): State => {
  switch (action.type) {
    case Actions.GET_LABORER_SALARY_CHANGE_REQUESTS_ASYNC:
    case Actions.GET_LABORER_SALARY_CHANGE_REQUESTS_FAIL:
      return {
        ...state,
        ...action.status,
      }

    case Actions.GET_LABORER_SALARY_CHANGE_REQUESTS_SUCCESS: {
      return {
        ...state,
        ...action.status,
        requests: action.payload.data.map(convertSalaryChangeRequestFromResponse),
      }
    }

    default:
      return state
  }
}
